module.exports = __webpack_public_path__ + "static/media/kowalskis-logo.ae3ea259.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/views/whereToBuy/stores/kowalskis-logo.jpeg
// module id = 242
// module chunks = 0